import {mergeMap as _observableMergeMap, catchError as _observableCatch, } from "rxjs/operators";
import {Observable,throwError as _observableThrow,of as _observableOf,of, observable} from "rxjs";   
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";  
import {HttpClient, HttpHeaders, HttpResponse,HttpResponseBase} from "@angular/common/http";
import { API_BASE_URL, BaseClient } from "./baseclient";
import { ProblemDetails } from "../models/problemdetails";
import { Position } from "../models/userPosition";
import { RoleResponse } from "../models/roleresponse";
@Injectable({
    providedIn: "root",
  })
export class SettingsClient extends  BaseClient
{
    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
       super(http,baseUrl);
   
    }
    getPositions()
    {
        let url_ = this.baseUrl + "/settings";
      
        url_ = url_.replace(/[?&]$/, "");
       
        let options_: any = {
          observe: "response",
          responseType: "blob",
          headers: new HttpHeaders({
            Accept: "application/json",
          }),
        };
    
        return this.http
          .request("get", url_, options_)
          .pipe(
            _observableMergeMap((response_: any) => {
                
              return this.processGetSettings(response_);
            })
          )
          .pipe(
            _observableCatch((response_: any) => {
               
              if (response_ instanceof HttpResponseBase) {
                try {
                  return this.processGetSettings(response_ as any);
                } catch (e) {
                  return _observableThrow(e) as any as Observable<
                  Position[]
                  >;
                }
              } else
                return _observableThrow(response_) as any as Observable<
                Position[]
                >;
            })
          );
    }
    
 protected processGetSettings(
    response: HttpResponseBase
  ): Observable<Position[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
             
          if (Array.isArray(resultData200.positions)) {
            result200 = [] as any;
            for (let item of resultData200.positions){
              result200!.push(Position.fromJS(item));
             
            }
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return this.throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<Position[]>(null as any);
   
  }
  getRoles()
  {
      let url_ = this.baseUrl + "/settings";
    
      url_ = url_.replace(/[?&]$/, "");
     
      let options_: any = {
        observe: "response",
        responseType: "blob",
        headers: new HttpHeaders({
          Accept: "application/json",
        }),
      };
  
      return this.http
        .request("get", url_, options_)
        .pipe(
          _observableMergeMap((response_: any) => {
              
            return this.processGetRoles(response_);
          })
        )
        .pipe(
          _observableCatch((response_: any) => {
             
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetRoles(response_ as any);
              } catch (e) {
                return _observableThrow(e) as any as Observable<
                Position[]
                >;
              }
            } else
              return _observableThrow(response_) as any as Observable<
              Position[]
              >;
          })
        );
  }
  
 protected processGetRoles(
    response: HttpResponseBase
  ): Observable<RoleResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
             
          if (Array.isArray(resultData200.userRoles)) {
            result200 = [] as any;
            for (let item of resultData200.userRoles){
              result200!.push(RoleResponse.fromJS(item));
             
            }
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return this.throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<RoleResponse[]>(null as any);
   
  }
  getTitles()
  {
      let url_ = this.baseUrl + "/settings";
    
      url_ = url_.replace(/[?&]$/, "");
     
      let options_: any = {
        observe: "response",
        responseType: "blob",
        headers: new HttpHeaders({
          Accept: "application/json",
        }),
      };
  
      return this.http
        .request("get", url_, options_)
        .pipe(
          _observableMergeMap((response_: any) => {
              
            return this.processGetTitles(response_);
          })
        )
        .pipe(
          _observableCatch((response_: any) => {
             
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGetTitles(response_ as any);
              } catch (e) {
                return _observableThrow(e) as any as Observable<
                string[]
                >;
              }
            } else
              return _observableThrow(response_) as any as Observable<
              string[]
              >;
          })
        );
  }
  protected processGetTitles(
    response: HttpResponseBase
  ): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
             
          if (Array.isArray(resultData200.titles)) {
            result200 = [] as any;
            for (let item of resultData200.titles){
              result200!.push(item);
             
            }
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "Access token specified in Authorization header is invalid",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return this.throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return new Observable<string[]>(null as any);
   
  }
  

}